import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function AboutUs() {
    return (
        <section className="space-y-10">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    About Us
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    EventFlow is a purpose-built banquet and event management platform
                    designed to simplify operations, improve financial control, and
                    enhance customer experience.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-2">Overview</h2>
                    <p className="text-sm text-slate-600">
                        EventFlow was created to replace fragmented registers, spreadsheets,
                        and disconnected tools with a single unified system.
                    </p>
                </section>
            </section>

            {/* OUR VISION */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    Our Vision
                </h2>

                <p className="text-md text-slate-600 max-w-3xl">
                    Our vision is to empower banquet owners and event operators with
                    technology that brings clarity, control, and confidence to daily
                    operations.
                </p>
            </section>

            {/* OUR MISSION */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    Our Mission
                </h2>

                <p className="text-md text-slate-600 max-w-3xl">
                    To revolutionize the event management industry by providing a seamless, 
                    intuitive, and robust platform that bridges the gap between traditional 
                    practices and modern efficiency. We aim to be the backbone of successful 
                    events worldwide.
                </p>
            </section>

            {/* CORE VALUES */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Our Core Values
                </h2>

                <div className="grid md:grid-cols-3 gap-6">
                    <div>
                        <h3 className="font-semibold text-slate-800 mb-2">Integrity</h3>
                        <p className="text-sm text-slate-600">
                            We build trust through transparency, honesty, and reliable service 
                            in every interaction.
                        </p>
                    </div>
                    <div>
                        <h3 className="font-semibold text-slate-800 mb-2">Innovation</h3>
                        <p className="text-sm text-slate-600">
                            We constantly evolve our platform to meet the changing needs of 
                            the dynamic event industry.
                        </p>
                    </div>
                    <div>
                        <h3 className="font-semibold text-slate-800 mb-2">Customer Success</h3>
                        <p className="text-sm text-slate-600">
                            Your growth is our priority. We are dedicated to providing tools 
                            that drive your business forward.
                        </p>
                    </div>
                </div>
            </section>

            {/* WHAT WE SOLVE */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Problems We Solve
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Manual booking registers and data duplication</li>
                    <li>Double bookings and scheduling conflicts</li>
                    <li>Untracked payments and financial leakage</li>
                    <li>Lack of real-time reporting</li>
                    <li>Uncontrolled user access</li>
                </ul>
            </section>

            {/* WHO WE SERVE */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    Who We Serve
                </h2>

                <p className="text-md text-slate-600 max-w-3xl mb-4">
                    EventFlow is trusted by banquet halls, wedding venues, event planners,
                    and hospitality businesses looking for structured growth.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>
                        <strong className="text-slate-800">Banquet Halls:</strong> Streamline booking calendars and manage multiple halls effortlessly.
                    </li>
                    <li>
                        <strong className="text-slate-800">Wedding Venues:</strong> Coordinate complex wedding logistics and client requirements with ease.
                    </li>
                    <li>
                        <strong className="text-slate-800">Corporate Event Planners:</strong> Manage large-scale corporate events with precision and professionalism.
                    </li>
                    <li>
                        <strong className="text-slate-800">Community Centers:</strong> Organize community gatherings and resource allocation efficiently.
                    </li>
                </ul>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, learn about{" "}
                    <Link to="/docs/support" className="font-medium text-[#C9A24E]">
                        Support
                    </Link>.
                </p>
            </section> */}
<DocNavigation
                    previous={{
                      title: "Data Migration",
                      link: "/docs/data-migration"
                    }}
                    next={{
                      title: "Support",
                      link: "/docs/support"
                    }}
                  />
        </section>
    );
}
